import CommonImg from "@/components/Common/Img";

import CloseIcon from "@/assets/images/close-icon.png";
import { cn } from "@/libs/utils";

type Props = {
  index: number;
  label: string;
  onDelete: () => void;
  className?: string;
};
export default function KeywordItem({
  index,
  label,
  onDelete,
  className,
}: Props) {
  return (
    <div
      key={index}
      className={cn(
        "px-[12px] py-[8px] text-white bg-dark-red rounded-[15px] text-[10px] flex items-center",
        className
      )}
    >
      <div className="w-full flex justify-center min-w-[50px] whitespace-nowrap">
        {label}
      </div>
      <CommonImg
        src={CloseIcon}
        alt="Close"
        className="size-[8px] object-contain cursor-pointer ml-[8px]"
        onClick={() => onDelete()}
      />
    </div>
  );
}
